import { Store, ActionTree, ActionContext } from 'vuex'
import { State } from './state'
import { StatsPobraniaService } from "@/services/stats-pobrania.service";
import { DataTablePaginatorAndProduct } from "@/store/modules/dashboard/types";
import { ForceUpdateAndLastYear, ProductIdAndLastYear } from "@/pitprojekt/types";
import _ from 'lodash'

export async function updateAggregatedStatsPobraniaSum(store: ActionContext<State, any>, params: ForceUpdateAndLastYear) {
    store.commit('updatingAggregatedStatsPobraniaSum', params.forceUpdate);

    for (let index in store.rootState.SettingsModule.selectedProducts) {
        let productId: number = store.rootState.SettingsModule.selectedProducts[index];

        if (_.find(store.state.aggregatedStatsPobraniaSumBuffer, function(o) { return o.productId == productId; }) == undefined) {
            store.dispatch('getAggregatedStatsPobraniaSumBetweenDatesForProduct', {'productId': productId, 'lastYear': params.lastYear});
        }
        else
            store.commit('updatedAggregatedStatsPobraniaSum');
    }

}

export async function getAggregatedStatsPobraniaSumBetweenDatesForProduct(store: ActionContext<State, any>, params: ProductIdAndLastYear) {
    try {
        const aggregatedStatsPobrania = await StatsPobraniaService.getAggregatedSumBetweenDates(params.productId, store.rootState.SettingsModule.dateFrom, store.rootState.SettingsModule.dateTo, params.lastYear);
        store.commit('loadedAggregatedStatsPobraniaSumForProduct', {'productId': params.productId, 'stat': aggregatedStatsPobrania.sum});
        if (store.state.aggregatedStatsPobraniaSumBuffer.length === store.rootState.SettingsModule.selectedProducts.length) {
            store.commit('updatedAggregatedStatsPobraniaSum');
        }
        return true;
    }
    catch (error) {
        return false;
    }
}


export async function getAggregatedStatsPobraniaBetweenDatesForProduct(store: ActionContext<State, any>,  paginator: DataTablePaginatorAndProduct) {
    store.commit('loadingAggregatedStatsPobraniaBetweenDatesForProduct');
    try {
        const aggregatedStatsPobrania = await StatsPobraniaService.getAggregatedBetweenDates(paginator.page, paginator.itemsPerPage, store.rootState.SettingsModule.dateFrom, store.rootState.SettingsModule.dateTo, paginator.lastYear, false, paginator.productId);
        store.commit('loadedAggregatedStatsPobraniaForProduct', {data: aggregatedStatsPobrania.data.data, currentPage: aggregatedStatsPobrania.data.current_page, total: aggregatedStatsPobrania.data.total});

        return true;
    }
    catch (error) {
        return false;
    }
}

export async function getDetailedStatsPobraniaBetweenDatesForProduct(store: ActionContext<State, any>,  params: ProductIdAndLastYear) {
    store.commit('loadingDetailedStatsPobraniaBetweenDatesForProduct');
    try {
        const detailedStatsPobrania = await StatsPobraniaService.getDetailedListBetweenDates(params.productId, store.rootState.SettingsModule.dateFrom, store.rootState.SettingsModule.dateTo, params.lastYear);
        store.commit('loadedDetailedStatsPobraniaForProduct', detailedStatsPobrania);

        return true;
    }
    catch (error) {
        return false;
    }
}


export default <ActionTree<State, any>> {
    updateAggregatedStatsPobraniaSum, getAggregatedStatsPobraniaSumBetweenDatesForProduct, getAggregatedStatsPobraniaBetweenDatesForProduct, getDetailedStatsPobraniaBetweenDatesForProduct
}
